module.exports = __webpack_public_path__ + "img/step20_2_mfp_slide_refeed_preventers.98109298.png";